export { LeadMagnet as GatedReportCta } from "./lead-magnet"
export type { LeadMagnetProps as GatedReportCtaProps } from "./lead-magnet"
